import { useFetchData } from "./query";

import productService from "../redux/product-management/product-management-service";

export default function useProducts(productFilters = {}, categoryFilters = []) {
  const { data: products, isLoading } = useFetchData(
    ["products", productFilters],
    () => productService.getAllProducts(productFilters)
  );

  const { data: brandList } = useFetchData(
    ["brandList"],
    () => productService.getProductBrandListing(),
    {
      staleTime: 1000 * 60 * 20,
      cacheTime: 1000 * 60 * 20,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  const { data: categoryList } = useFetchData(
    ["categories"],
    () => productService.getProductCategoryListing(),
    {
      staleTime: 1000 * 60 * 20,
      cacheTime: 1000 * 60 * 20,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  const { data: newArrivalList } = useFetchData(
    ["newArrival"],
    () => productService.getProductNewArrivalListing(),
    {
      staleTime: 1000 * 60 * 20,
      cacheTime: 1000 * 60 * 20,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  return {
    productList: products,
    brandList: brandList?.brands,
    categoryList: categoryList?.categories,
    newArrivalList: newArrivalList?.products,
    isLoading,
  };
}
